import { X } from 'lucide-react';
import React from 'react'

const QuestionBox = ({ children, onRemove, bgColor, onQueClick }) => {
  return (
    <button
      style={{
        backgroundColor: bgColor
      }}
      className={`inline-flex items-center  text-[#323232] rounded-[8px] py-1 pl-3 pr-2 text-sm font-medium cursor-pointer hover:bg-blue-100 transition-colors`}
      onClick={() => {
        onQueClick()
      }}

    >
      <span >{children}</span>
      <button
        className="ml-1 rounded-full p-1 hover:bg-blue-200 transition-colors"
        onClick={(e) => {
          e.stopPropagation()
          onRemove()

        }}
      >
        <X size={14} />
      </button>
    </button>
  )
}

export default QuestionBox